const PLAYER_ICON_FILES = {
  ranger: 'ranger.png',
  'ranger-scout': 'ranger-scout.png',
  'ranger-spy': 'ranger-scout.png',
  'ranger-medic': 'ranger-medic.png',
  'ranger-heavy': 'ranger.png',
};

export const RANGER_PLAYER_TEXTURE_KEY = 'ranger-player-icon';

export function createPreloadScene({ level, selectedPlayableIcon }) {
  return {
    key: 'RangerPreloadScene',

    preload() {
      const iconFile = PLAYER_ICON_FILES[selectedPlayableIcon] ?? PLAYER_ICON_FILES.ranger;
      this.load.image(
        RANGER_PLAYER_TEXTURE_KEY,
        `${process.env.PUBLIC_URL}/game-icons/${iconFile}`
      );
    },

    create() {
      this.scene.start('RangerMissionScene', {
        level,
        selectedPlayableIcon,
      });
    },
  };
}
